import { Pressable, StyleSheet, View } from 'react-native';
import { Bot, MoreHorizontal } from 'lucide-react-native';
import { tokens } from '../../theme/tokens';
import { AppText } from '../ui/AppText';

type AiAssistantHeaderProps = {
  title: string;
  subtitle: string;
  onPressAvatar: () => void;
  onPressMore: () => void;
};

export function AiAssistantHeader({
  title,
  subtitle,
  onPressAvatar,
  onPressMore,
}: AiAssistantHeaderProps) {
  return (
    <View style={styles.header}>
      <Pressable accessibilityRole="button" onPress={onPressAvatar} style={styles.avatar}>
        <Bot size={24} color={tokens.colors.white} />
      </Pressable>
      <View style={styles.copy}>
        <AppText variant="title" weight="bold">
          {title}
        </AppText>
        <AppText variant="caption" tone="muted">
          {subtitle}
        </AppText>
      </View>
      <Pressable accessibilityRole="button" onPress={onPressMore} style={styles.moreButton}>
        <MoreHorizontal size={22} color={tokens.colors.text} />
      </Pressable>
    </View>
  );
}

const styles = StyleSheet.create({
  header: {
    minHeight: 58,
    flexDirection: 'row',
    alignItems: 'center',
    gap: tokens.spacing.md,
  },
  avatar: {
    width: 44,
    height: 44,
    borderRadius: 22,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: tokens.colors.primary,
  },
  copy: {
    flex: 1,
    gap: 2,
  },
  moreButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: tokens.colors.surface,
  },
});
